import { ZfLoadingSpinner } from '@zafire/react';
import { useEffect } from 'react';
import { Outlet } from 'react-router';
import { useClient } from '../../api';
import { resetClmDataUsageBanner } from '../../utils/clm-data-usage-banner-state';

export function SessionLayout() {
    const { isSuccess, isLoading } = useClient();

    useEffect(() => {
        resetClmDataUsageBanner();
    }, []);

    return (
        <>
            {isLoading && <ZfLoadingSpinner style={{ margin: 'auto' }} />}
            {isSuccess && <Outlet />}
        </>
    );
}
